export class ServiceRequestKioskosTable {
    public clientCode: string;
    public operationNum?: string;
    public reason: string;
    public creationDate?: Date;
    public state?: string;
    public result?: string;
    public coment?: string;

    public fec_Conclusion: Date;
    public fec_Admision: Date;
    public fec_Creacion: Date;
    public extension: boolean;
    public fec_Plan_Fin: boolean;

    public status_timeline: number;
    public estadoOperacion: string;
}


export enum statusTimelineKiosko {

    DERIVADO_CON_AVISO="derivado con aviso",
    AVISO_CERRADO = "aviso cerrado",
    ANULADO = "anulado",
    CONCLUIDO="concluido"

}